import { Button } from '@/components/ui/primitives';
import {
    CtaBand,
    ContextNote,
    FAQList,
    FeatureGrid,
    Hero,
    MarketingPage,
    PageFooter,
    StepList,
    Dateline,
} from '@/components/marketing';
import { pageForRoute } from '@/site/pageRegistry';
import copy from './share-pdf-drawings-for-review.content.json';

const PAGE = pageForRoute('/share-pdf-drawings-for-review');
const REQUEST_ACCESS_HREF = 'mailto:smalltigergroup@gmail.com?subject=PDF%20Markup%20Tool%20-%20Private%20Beta%20Access%20Request';

export function SharePdfDrawingsForReviewPage() {
    return (
        <MarketingPage head={{ ...PAGE.head, canonical: PAGE.canonical }}>
            <main>
                <Hero
                    eyebrow={copy.heroEyebrow}
                    title={copy.heroTitle}
                    lead={copy.heroLead}
                    cta={<Button href="/" variant="primary" size="lg">{copy.openDrawing}</Button>}
                    chips={copy.heroChips}
                />
                <ContextNote text={copy.localContext} />
                <StepList title={copy.stepsTitle} lead={copy.stepsLead} steps={copy.steps} />
                <FeatureGrid
                    sectionTitle={copy.featuresTitle}
                    sectionLead={copy.featuresLead}
                    cards={copy.features}
                />
                <CtaBand
                    title={copy.betaTitle}
                    lead={copy.betaLead}
                    actions={<Button href={REQUEST_ACCESS_HREF} variant="primary" size="lg">{copy.requestAccess}</Button>}
                />
                <FAQList items={copy.faq} />
                <CtaBand
                    title={copy.startTitle}
                    lead={copy.startLead}
                    actions={<Button href="/" variant="primary" size="lg">{copy.openDrawing}</Button>}
                />
                <Dateline reviewed={PAGE.reviewed} />
            </main>
            <PageFooter tagline={copy.footerTagline} />
        </MarketingPage>
    );
}
